module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/tv-h5.39a6445e.jpg";